/**
 * ÉPRIS Drawer-Duplicate Cleanup
 *
 * Theme leak fix (2026-05-04):
 * Prestige-Theme nutzt portal-pattern (sendToBody in theme.js:6825) das
 * cart-drawer für korrekten z-index nach <body> portalisiert. Aber bei jedem
 * Open/Close-Cycle wird die Original-Section-Variante NICHT geräumt → mehrfache
 * cart-drawer-Instanzen mit gleicher id="cart-drawer" akkumulieren im DOM.
 *
 * User-Symptom: Cart-Icon klicken, Drawer öffnet, schließen → noch eine sichtbar,
 * schließen → noch eine, etc. Bis zu 3+ X-Klicks nötig zum komplett-Schließen.
 *
 * Plus: priority-toggle, wishlist-heart und andere Code-Pfade benutzen
 * `getElementById('cart-drawer')` was nur den ERSTEN matched. Wenn das nicht
 * der aktive ist, geht der Update ins Leere.
 *
 * Fix: MutationObserver auf <body> + dedupe-Helper. Wenn mehr als 1 cart-drawer
 * im DOM, behalte nur einen — bevorzugt den AKTIVEN (open+visible), sonst den
 * Original-Section-Drawer.
 */
(function () {
  'use strict';

  if (window.__eprisDrawerCleanupActive) return;
  window.__eprisDrawerCleanupActive = true;

  let dedupeScheduled = false;

  function dedupeCartDrawers() {
    dedupeScheduled = false;
    const drawers = Array.from(document.querySelectorAll('cart-drawer'));
    if (drawers.length <= 1) return;

    // Identify aktiver Drawer (hat open attr + ist visible) — den wollen wir behalten
    let primary = drawers.find((d) => {
      if (!d.hasAttribute('open')) return false;
      const cs = getComputedStyle(d);
      return cs.display !== 'none' && cs.visibility !== 'hidden';
    });

    // Fallback: Original-Section-Drawer (in shopify-section-X__cart-drawer)
    if (!primary) {
      primary = drawers.find((d) => d.closest('[id^="shopify-section"]'));
    }
    // Letzter Fallback: einfach den ersten
    if (!primary) primary = drawers[0];

    drawers.forEach((d) => {
      if (d !== primary) {
        try { d.remove(); } catch (e) {}
      }
    });

    if (drawers.length > 1) {
      console.info('[ÉPRIS] cart-drawer dedupe: ' + (drawers.length - 1) + ' duplicate(s) removed');
    }
  }

  function schedule() {
    if (dedupeScheduled) return;
    dedupeScheduled = true;
    // RAF + microtask delay: Theme's portal-Operation ist synchron, aber wir wollen
    // erst nach dem nächsten Paint den DOM-State checken
    requestAnimationFrame(() => {
      Promise.resolve().then(dedupeCartDrawers);
    });
  }

  // 1. Initial: dedupe sofort beim Page-Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // 2. MutationObserver: feuert wenn cart-drawer zum body added/moved wird
  const observer = new MutationObserver((mutations) => {
    let cartDrawerInvolved = false;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.tagName === 'CART-DRAWER' || (node.id === 'cart-drawer'))) {
          cartDrawerInvolved = true;
          break;
        }
      }
      if (cartDrawerInvolved) break;
    }
    if (cartDrawerInvolved) schedule();
  });
  observer.observe(document.body, { childList: true });

  // 3. Cart-Events können Drawer-Replacements triggern → safety-dedupe
  ['cart:change', 'cart:refresh', 'cart:updated', 'cart:built', 'cart:rebuilt'].forEach((evt) => {
    document.addEventListener(evt, schedule);
  });

  // 4. Drawer-Open-Event: wenn drawer.show() läuft, oft entstehen die Duplikate
  document.addEventListener('dialog:after-show', schedule);
  document.addEventListener('dialog:after-hide', schedule);

  // 5. Periodischer Safety-Net (alle 5s) — fängt was die Observer verfehlen
  setInterval(dedupeCartDrawers, 5000);
})();
